// React
import React, { useState, useEffect, useContext } from "react";
// React
// CSS
import styles from "./Comments.module.css";
// CSS
// Models
import { I_Comment } from "../../../Models/interfaces";
// Models
// Services
import { getCommentsForTeachingItemService } from "../../../Services/parts/get/getCommentsForTeachingItemService";
// Services
// Modules
import { useParams } from "react-router-dom";
// Modules
// Contexts
import { UserTokenContext } from "../../../Contexts/userToken";
// import { LessonDataContext } from "../../../Contexts/LessonDataContext";
// Contexts
// Utils
import HelperHeader from "../../../Utils/HelperHeader/HelperHeader";
import { profileImg } from "../../../Images/images";
import parse from "html-react-parser";
import { toast } from "react-toastify";
import PendingAndErrorManager from "../../../Components/PendingAndErrorManager/PendingAndErrorManager";
// Utils
// Icons
// Icons

type CommentsProps = {
  isModalOpen: boolean;
  setIsCommentModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const Comments: React.FunctionComponent<CommentsProps> = ({
  isModalOpen,
  setIsCommentModalOpen,
}) => {
  const { teachItemId } = useParams();
  const [comments, setComments] = useState<I_Comment[]>([]);
  const userToken = useContext(UserTokenContext);
  const [isPending, setIsPending] = useState<boolean>(false);
  // const lessonData = useContext(LessonDataContext);
  useEffect(() => {
    setIsPending(true);
    getCommentsForTeachingItemService(userToken, String(teachItemId))
      .then(({ data: { data } }) => {
        setComments(data);
      })
      .catch((err) => {
        console.log(err);
        toast(
          err.response.data.message ? err.response.data.message : err.message
        );
      })
      .finally(() => {
        setIsPending(false);
      });
  }, [userToken, teachItemId]);

  return (
    <div
      className={`${styles.commentsContainer} w-full  overflow-y-scroll  ${
        isModalOpen ? "z-0" : "z-10"
      }  px-4 `}
      style={{
        paddingBottom: "7vh",
      }}
    >
      <PendingAndErrorManager
        isDone={!isPending}
        isError={false}
        isPending={isPending}
        onError={() => {}}
        showAfterDone={
          <>
            <HelperHeader
              absoluteText="نظرات کاربران"
              className="!bg-gray-600 mt-5"
            />
            {comments.map((item) => (
              <div
                className={`${styles.commentItemContainer}  py-2 pb-3 `}
                key={item.id}
              >
                <div className="w-full flex flex-row-reverse items-center">
                  <img
                    src={profileImg}
                    alt=""
                    className="w-10 h-10 rounded-full"
                  />
                  <div
                    className={`${styles.data} flex flex-col items-end text-sm mr-2 w-10/12`}
                  >
                    <p className="text-sm">{item.user.fullName}</p>
                    <p className="text-xs text-right">{item.text}</p>
                  </div>
                </div>
                {item.reply !== null &&
                String(item.reply) !== "null" &&
                item.reply !== undefined ? (
                  <div className="w-full flex flex-col items-end pr-14 mt-2">
                    <div className="text-sm font-bold">: پاسخ </div>
                    <div className="text-right text-xs ">
                      {parse(String(item.reply.text))}
                    </div>
                  </div>
                ) : null}
              </div>
            ))}

            <button
              className={`${styles.addCommentBtn} fixed left-5 
        
       ${
         //' bottom-10'
         ""
       }
        
        z-20 w-10 h-10 rounded-full bg-purple-500 text-sm text-white `}
              onClick={() => {
                setIsCommentModalOpen(true);
              }}
              style={{
                bottom: "8vh",
              }}
            >
              نظر
            </button>
          </>
        }
      />
    </div>
  );
};

export default Comments;
